<template>
  <router-view v-if="isRouterAlive" />
</template>
<script>

const env = process.env.NODE_ENV
if (env == 'production') {
  
}
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true
    };
  },
  provide() {
    return {
      reload: this.reload
    }
  },

  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
};

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue